import React from 'react';
import {
  Stack,
  Icon,
  Text,
} from '@piwikpro/ui-components';

export interface IFailMessageProps {
  t: (key: string) => string
}

export const FailMessage = ({ t }: IFailMessageProps) => (
  <Stack
    vertical
    horizontalAlignment="middle"
    verticalAlignment="center"
    spacing="extraWide"
  >
    <Stack.Item fill />
    <Stack.Item>
      <Stack
        vertical
        horizontalAlignment="middle"
      >
        <Stack.Item>
          <Icon
            color="red"
            name="exclamation-mark-circle"
            size="medium"
          />
        </Stack.Item>
        <Stack.Item>
          <Text color="Red" dataId="TextStyle.Red">
            {t('general.cardWithControls.failMessage.description')}
          </Text>
        </Stack.Item>
      </Stack>
    </Stack.Item>
    <Stack.Item fill />
  </Stack>
);

export default FailMessage;
